import { render, staticRenderFns } from "./ArticleIcon.vue?vue&type=template&id=25420c80&"
import script from "./ArticleIcon.vue?vue&type=script&lang=js&"
export * from "./ArticleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports